import React from "react";
import NearMeRoundedIcon from "@mui/icons-material/NearMeRounded";
import { Box, Button, Typography } from "@mui/material";

export default function NetworkInviteCard({ onInvite }) {
  return (
    <Box
      sx={{
        p: 2.15,
        borderRadius: 3,
        bgcolor: "rgba(106, 87, 255, 0.08)",
        border: "1px solid rgba(106, 87, 255, 0.08)",
      }}
    >
      <Box
        sx={{
          width: 50,
          height: 50,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          bgcolor: "rgba(23, 52, 93, 0.1)",
          color: "#17345d",
          mb: 1.35,
        }}
      >
        <NearMeRoundedIcon />
      </Box>
      <Typography variant="subtitle1" fontWeight={800} sx={{ color: "#2c3556" }}>
        Invite someone to join you
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.7, mb: 2, color: "#67758e" }}>
        Accountability works better together.
      </Typography>
      <Button
        variant="contained"
        onClick={onInvite}
        sx={{
          borderRadius: 2.4,
          px: 1.95,
          textTransform: "none",
          fontWeight: 700,
          background: "linear-gradient(135deg, #254b79 0%, #17345d 100%)",
        }}
      >
        Invite friends
      </Button>
    </Box>
  );
}
